import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { formatINR, formatDateTime } from "@/lib/format";

interface Order {
  _id: string;
  symbol: string;
  side: "BUY" | "SELL";
  type: "MARKET" | "LIMIT";
  qty: number;
  price: number;
  status: string;
  mode: "REAL" | "VIRTUAL";
  createdAt: string;
}

export default function Orders() {
  const { data: ordersResp, isLoading, error } = useQuery<{ data: Order[]; total: number }>({
    queryKey: ["orders"],
    queryFn: () => api.get("/orders"),
  });
  const orders = ordersResp?.data ?? [];

  return (
    <div>
      <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 20 }}>
        Orders
      </h1>

      <div className="card">
        {isLoading && <div style={{ padding: 20, color: "var(--text-muted)" }}>Loading orders…</div>}
        {error && <div style={{ padding: 20, color: "var(--red-light)" }}>Error: {error.message}</div>}
        {orders && orders.length === 0 && (
          <div style={{ padding: 20, color: "var(--text-muted)" }}>No orders found</div>
        )}
        {orders && orders.length > 0 && (
          <table>
            <thead>
              <tr>
                <th>Time</th>
                <th>Symbol</th>
                <th>Side</th>
                <th>Type</th>
                <th>Mode</th>
                <th style={{ textAlign: "right" }}>Qty</th>
                <th style={{ textAlign: "right" }}>Price</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o._id}>
                  <td style={{ fontSize: 12, color: "var(--text-muted)" }}>{formatDateTime(o.createdAt)}</td>
                  <td style={{ fontWeight: 600 }}>{o.symbol}</td>
                  <td style={{ color: o.side === "BUY" ? "var(--green-light)" : "var(--red-light)", fontWeight: 500 }}>
                    {o.side}
                  </td>
                  <td>{o.type}</td>
                  <td>
                    <span style={{
                      fontSize: 10, fontWeight: 700, padding: "2px 6px", borderRadius: 4,
                      background: o.mode === "REAL" ? "var(--green)" : "var(--amber)", color: "#fff",
                    }}>
                      {o.mode}
                    </span>
                  </td>
                  <td style={{ textAlign: "right", fontFamily: "var(--font-mono)" }}>{o.qty}</td>
                  <td style={{ textAlign: "right", fontFamily: "var(--font-mono)" }}>
                    {o.type === "MARKET" ? "MKT" : formatINR(o.price)}
                  </td>
                  <td>
                    <span style={{
                      fontSize: 11, fontWeight: 600, textTransform: "uppercase",
                      color: o.status === "FILLED" ? "var(--green-light)" : o.status === "REJECTED" ? "var(--red-light)" : "var(--amber)",
                    }}>
                      {o.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
